import React, { useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import { deleteEvent } from "../../actions/eventActions";
import DeleteModel from "../../VibehutUI/DeleteModel";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function DeleteEvent({
  isOpen,
  setIsOpen,
  event,
  isFromEventPage = false,
  getEvent = undefined,
}) {
  const { state, dispatch } = useContext(StoreContext);
  const history = useHistory();
  const {
    auth: {
      user: { token },
    },
    event: { isFetching },
  } = state;

  const handleDelete = (isGroupDelete) => {
    deleteEvent(event._id, token, dispatch, isGroupDelete).then(() => {
      setIsOpen(false);
      if (getEvent && isGroupDelete) {
        getEvent();
      }
      if (isFromEventPage) {
        history.push("/");
      }
    });
  };

  return (
    <DeleteModel
      handleDelete={handleDelete}
      title={event.title}
      isFetching={isFetching}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      text={" Are you sure to delete this event ?"}
      isCheckBoxActive={!!event?.isRecurrEvent}
    />
  );
}
